import request from 'utils/request'
import { encrypt } from 'utils/common'

export function login (username, password) {
  // 管理端登录接口
  return request.post('auth/login', {
    username,
    password: encrypt(password)
  })
}

export function logout () {
  return request.get('auth/logout', undefined, { hideError: true })
}

export function getUserMenus (username) {
  return request.get(`menu/${username}`, undefined, { hideError: true })
}
